import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICalculationResult } from '../../../../../../models/calculation-result.model';

@Component({
    templateUrl: './cost-accounting-error-dialog.component.html',
    styleUrls: [ './cost-accounting-error-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostAccountingErrorDialogComponent {

    constructor(private myMatDialogRef: MatDialogRef<CostAccountingErrorDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: ICalculationResult) {
    }

    public close(): void {
        this.myMatDialogRef.close();
    }
}
